import React, { useRef } from 'react'
import { Banner } from './banner'
import { Pricingtable } from './pricingtable'

export const ResourcesPrice = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  return (
    <>
    <Banner scrollRef={scrollRef}/>
    <Pricingtable ref={scrollRef}/>
    </>
  )
}
